<template>
  <div class="signature-container">
    <div class="title">专家签名区</div>
    <canvas ref="signaturePad" class="signature-pad" id="img"></canvas>
    <div v-if="!hasSubmit">
      <button @click="clearSignature" class="signature-button">清除</button>
      <button @click="saveSignature" class="signature-button" v-loading.fullscreen.lock="fullscreenLoading">保存</button>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';
import reviewBusinessService from "@/api/review/reviewBusinessApi";

export default {
  name: 'ElectronicSignature',
  data() {
    return{
      fullscreenLoading: false,
      hasSubmit: false,
      ids:[]
    }
  },
  created() {
    const ids = this.$route.query.ids
    this.ids = ids
    console.log(this.ids)
  },
  mounted() {
    this.initSignaturePad();
  },
  methods: {
    initSignaturePad() {
      const canvas = this.$refs.signaturePad;
      const radio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth*radio;
      canvas.height=canvas.offsetHeight*radio;
      canvas.getContext("2d").scale(radio,radio)

      this.signaturePad = new SignaturePad(canvas, {
        minDistance: 2,
        width: window.innerWidth + radio,
        minWidth: 0.5,
        maxWidth: 2,
        throttle: 60,
        velocityFilterWeight:0.5,
        backgroundColor: '#ffffff', // 透明背景
        penColor: 'rgb(0, 0, 0)'
      });
    },
    checkPage() {

    },
    clearSignature() {
      this.signaturePad.clear();
    },
    saveSignature() {
      const data = this.signaturePad.toDataURL('image/jpeg',0.3);
      if (this.signaturePad.isEmpty()){
        this.$alert("请签名后进行保存")
        return
      }
      let params = {
        "secretIds": this.ids,
        "signature": data
      }
      this.fullscreenLoading = true
      reviewBusinessService.saveSigData(params).then(data => {
        this.$alert("操作成功,请直接退出当前页面，不要重复提交")
        this.hasSubmit = true
      }).catch(err => {
        this.$message({
          type: 'error',
          message: err.response.data.message
        })
      }).finally(() => {
        this.fullscreenLoading = false
      });
    }
  }
};
</script>

<style>

.title {
  font-size: 51px;
  color: #ffffff;
  width: 300px;
  background: #1F87F0;
  align-items: center;
}

.signature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 500px;
}
.signature-button {
  padding: 10px 20px;
  margin: 5px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  transition: background-color 0.3s;
}
.signature-button:hover, .signature-button:focus {
  background-color: #0056b3;
}



.signature-pad {
  border: 1px solid #ccc;
  width: 300px;
  height: 150px;
}
</style>
